module.exports = __webpack_public_path__ + "static/media/uggc-avocats@2x.a88638a3.png";